import React from 'react';
import { icons } from './icons';

type Props = React.SVGProps<SVGSVGElement> & {
  icon: keyof typeof icons;
};

export const Icon = ({ icon, className = '', style = {}, ...rest }: Props) => {
  const IconSVG = icons[icon] || icons.lightBulb;

  return React.cloneElement(IconSVG as any, { ...rest, className, style });
};
